import * as React from 'react'

const Facebook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-hidden='true'
    fill='none'
    height='20'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Facebook logo</title>
    <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
  </svg>
)

export default Facebook



// WEBPACK FOOTER //
// ./src/components/icons/ui/Facebook.tsx